import { Tag, TagVariant } from '@estimateone/frontend-components';

export const NewTag = () => <Tag variant={TagVariant.Practical500}>NEW</Tag>;
